import { string, z } from 'zod'
import { mongoId } from '../utils/basicSchemas/_id.z.schema'
import { ZSchema } from '../utils/zodSchema'


const transactionSchema = z.object({
    transactionAmount: z.number().min(0, "Amount is invalid")
})


const transactionParamsSchema = z.object({
    username: string().min(1, "Username is invalid")
})
const transactionIdSchema = z.object({
    id: mongoId("transaction id"),
})


const transactionValidator = new ZSchema({ bodySchema: transactionSchema, paramSchema: transactionParamsSchema })
const transactionIdValidator = new ZSchema({ paramSchema: transactionIdSchema })


// TODO: UNTESTED:
export { transactionValidator, transactionIdValidator }
